// extracted by mini-css-extract-plugin
export default {"container":"Zk-z","freeShip":"_k-z","privacy":"al-z"};